<template>
  <div class="empty-indicator" v-bind="$attrs">
    <img :width="width" :src="require('@/assets/img_' + indicator + '.svg')" />
    <span class="description">{{ description }}</span>
  </div>
</template>
<style lang="scss">
.empty-indicator {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .description {
    margin-top: 2em;
    text-align: center;
  }
}
</style>
<script lang="ts">
import { defineComponent, onMounted, PropType, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

export enum EmptyIndicatorType {
  emptyList = "empty_list",
  noResult = "no_result",
  error = "error",
}
export default defineComponent({
  props: {
    description: String,
    indicator: String,
    width: {
      type: Number,
      default: 220,
    }
  },

  setup(props) {
    const t = useI18n().t;

    onMounted(async () => {

    });

    return {
      t,
    };
  },
});
</script>

